import { render, staticRenderFns } from "./UsersTable.vue?vue&type=template&id=42e1a5fe&"
import script from "./UsersTable.vue?vue&type=script&lang=js&"
export * from "./UsersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports